<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="row regulatory_row">
  <div class="col-lg-3" *ngIf="regulationLibraryType !== 1 && urlType !== 'Future Updates'">
    <div class="form-group">
      <div class="left inline control-label mb-1">Published From</div>
      <div class="input-group input-group-sm" *ngIf="regulationFilter && regulationFilter.FromDate">
        <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder="Choose a date"
          class="form-control form-control-sm border-bottom" id="fromDate" placeholder="From"
          [(ngModel)]="regulationFilter.FromDate" readonly>
        <div class="input-group-append">
          <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
        </div>
      </div>
      <mat-datepicker #picker></mat-datepicker>
    </div>
  </div>
  <div class="col-lg-3" *ngIf="regulationLibraryType !== 1 && urlType !== 'Future Updates'">
    <div class="form-group">
      <div class="left inline control-label d-none d-sm-block mb-1">Published Until</div>
      <div class="input-group input-group-sm" *ngIf="regulationFilter && regulationFilter.FromDate">
        <input matInput [matDatepicker]="toPicker" (click)="toPicker.open()" placeholder="Choose a date"
          class="form-control form-control-sm border-bottom" id="toDate" placeholder="To"
          [(ngModel)]="regulationFilter.ToDate" readonly>
        <div class="input-group-append">
          <span class="input-group-text fa fa-calendar" (click)="toPicker.open()"></span>
        </div>
      </div>
      <mat-datepicker #toPicker></mat-datepicker>
    </div>
  </div>
  <div class="col-lg-2" *ngIf="regulationFilter.RegulationId.length<=5">
    <div class="form-group">
      <div class="left inline control-label mb-1">Id </div>
      <mat-chip-grid #idList>
        <mat-chip-row *ngFor="let type of regulationFilter.RegulationId" [selectable]="selectable" [removable]="removable"
          (removed)="removeRegulationId(type)">
          {{type}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm border-bottom" type="number" id="type" autocomplete="off"
          [matChipInputFor]="idList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRegulationId($event)">
      </mat-chip-grid>
    </div>
  </div>
  <div class="col-lg-2" *ngIf="regulationFilter.RegulationId.length>5 && regulationFilter.IsSimilarId">
    <div class="form-group">
      <div class="left inline control-label mb-1">Id </div>
      <mat-chip-grid #idList>
        <mat-chip-row *ngFor="let type of multipleIds" [selectable]="selectable" [removable]="removable"
          (removed)="removeAllRegulationId()">
          {{type}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm border-bottom" type="number" id="type" autocomplete="off"
          [matChipInputFor]="idList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRegulationId($event)">
      </mat-chip-grid>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Geography </div>
      <mat-chip-grid #geographyList>
        <ng-container *ngFor="let geography of regulationFilter.Geography">
          <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="removeGeography(geography)">
            {{geography}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
        </ng-container>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #geographyInput
          [formControl]="searchGeographyCntrl" [matAutocomplete]="geographyAutoComplete"
          [matChipInputFor]="geographyList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addGeography($event)"
          (click)="openGeographyAutoComplete()" #geographyAutoTrigger="matAutocompleteTrigger">
      </mat-chip-grid>
      <mat-autocomplete #geographyAutoComplete="matAutocomplete" (optionSelected)="selectedGeographyEvent($event)">
        <mat-option *ngFor="let item of searchedGeographies" [value]="item.value">
          {{item.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Country </div>
      <mat-chip-grid #countryList>
        <ng-container *ngFor="let country of regulationFilter.Country">
          <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="removeCountry(country)">
            {{country}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
        </ng-container>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #countryInput
          [formControl]="searchCountryCntrl" [matAutocomplete]="countryAutoComplete" [matChipInputFor]="countryList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="addCountry($event)" (click)="openCountryAutoComplete()"
          #countryAutoTrigger="matAutocompleteTrigger">
      </mat-chip-grid>
      <mat-autocomplete #countryAutoComplete="matAutocomplete" (optionSelected)="selectedCountryEvent($event)">
        <mat-option *ngFor="let item of searchedCountries" [value]="item.value">
          {{item.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div [ngClass]="urlType === 'Actioned' ? 'col-lg-2' : 'col-lg-4'">
    <div class="form-group">
      <div class="left inline control-label mb-1">Regulator </div>
      <mat-chip-grid #regulatorList>
        <ng-container *ngFor="let regulator of regulationFilter.MappingID">
          <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="removeRegulator(regulator)">
            {{regulator}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
        </ng-container>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #regulatorInput
          [formControl]="searchRegulatorCntrl" [matAutocomplete]="regulatorAutocomplete"
          [matChipInputFor]="regulatorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRegulator($event)"
          (click)="openRegulatorAutoComplete()" #regulatorAutoTrigger="matAutocompleteTrigger">
      </mat-chip-grid>
      <mat-autocomplete #regulatorAutocomplete="matAutocomplete" (optionSelected)="selectedRegulatorEvent($event)">
        <mat-option *ngFor="let regulator of searchedRegulators" [title]="regulator.name" [value]="regulator.value">
          {{regulator.name}}
        </mat-option>
      </mat-autocomplete>
      <app-progress-bar [isLoading]="isLoadingFilters" class="loader-sm"></app-progress-bar>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Key Words</div>
      <mat-chip-grid #keywordsList>
        <mat-chip-row *ngFor="let sQuery of regulationFilter.SearchQuery" [selectable]="selectable" [removable]="removable"
          (removed)="remove(sQuery)">
          {{sQuery}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #keywordInput [formControl]="keyCtrl"
          [matAutocomplete]="autoKeyword" [matChipInputFor]="keywordsList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)">
      </mat-chip-grid>
      <mat-autocomplete #autoKeyword="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let fK of filteredKeywords | async" [value]="fK">
          {{fK}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Type</div>
      <mat-chip-grid #typeList>
        <mat-chip-row *ngFor="let type of regulationFilter.Filters.PubType" [selectable]="selectable"
          [removable]="removable" (removed)="removeType(type)">
          {{type}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm border-bottom" id="type" autocomplete="off"
          [matChipInputFor]="typeList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addType($event)">
      </mat-chip-grid>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Title</div>
      <mat-chip-grid #titleList>
        <mat-chip-row *ngFor="let title of regulationFilter.Filters.Title" [selectable]="selectable" [removable]="removable"
          (removed)="removeTitle(title)">
          {{title}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm border-bottom" id="title" autocomplete="off"
          [matChipInputFor]="titleList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addTitle($event)">
      </mat-chip-grid>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Topic</div>
      <mat-chip-grid #topicList>
        <ng-container *ngFor="let topic of regulationFilter.Filters.RuleTopic">
          <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="removeTopic(topic)">
            {{topic}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
        </ng-container>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #ruleTopicInput
          [formControl]="searchRuleTopicFormControl" [matAutocomplete]="ruleTopicAutocomplete"
          [matChipInputFor]="topicList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addTopic($event)"
          (click)="openRuleTopicAutoComplete()" #ruleTopicAutoTrigger="matAutocompleteTrigger">
      </mat-chip-grid>

      <mat-autocomplete #ruleTopicAutocomplete="matAutocomplete" (optionSelected)="selectedTopicEvent($event)">
        <mat-option *ngFor="let topic of searchedTopics" [title]="topic.name" [value]="topic.value">
          {{topic.name}}
        </mat-option>
      </mat-autocomplete>

    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Linked Rules</div>
      <mat-chip-grid #linkedRulesList>
        <mat-chip-row *ngFor="let linkedRule of regulationFilter.Filters.LinkedRules" [selectable]="selectable"
          [removable]="removable" (removed)="removeLinkedRule(linkedRule)">
          {{linkedRule}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm border-bottom" id="linkedRules" autocomplete="off"
          [matChipInputFor]="linkedRulesList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addLinkedRule($event)">
      </mat-chip-grid>
    </div>
  </div>
  <div class="col-lg-2" *ngIf="groupByEnabled">
    <div class="form-group form-group-sm">
      <label class="left inline control-label mb-1">Group By</label>
      <div class="input-group input-group-sm">
        <select class="form-control form-control-sm border-bottom height31" [(ngModel)]="regulationFilter.GroupBy">
          <option value="PubType">Type</option>
          <option value="Country">Country</option>
          <option value="MappingId">Regulator</option>
        </select>
      </div>
    </div>
  </div>
  <div class="col-lg-2" *ngIf="urlType === 'Actioned' || regulationLibraryId > 0">
    <div class="form-group">
      <div class="left inline control-label mb-1">Status</div>
      <mat-chip-grid #statusList>
        <ng-container *ngFor="let items of regulationFilter.Status">
          <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="removeStatus(items)">
            {{items}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
        </ng-container>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #statusInput
          [formControl]="searchStatusCntrl" [matAutocomplete]="statusAutocomplete" [matChipInputFor]="statusList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="addStatus($event)">
      </mat-chip-grid>
      <mat-autocomplete #statusAutocomplete="matAutocomplete" (optionSelected)="selectedStatusEvent($event)">
        <mat-option *ngFor="let item of searchedStatus" [title]="item.value" [value]="item.value">
          {{item.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group form-group-sm">
      <label class="left inline control-label mb-1">Search Title</label>
      <input type="text" class="form-control form-control-sm border-bottom height31" [(ngModel)]="searchTitle" />
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group form-group-sm">
      <label class="left inline control-label mb-1">Saved Searches</label>
      <div class="input-group input-group-sm">
        <select class="form-control form-control-sm border-bottom height31" [(ngModel)]="savedFilterId"
          (change)="applyFilters($event.target.value)">
          <option *ngFor="let item of userRegulatorFilterData" value="{{item.id}}">{{ item.title }}</option>
          <option value="Today">Today</option>
          <option value="Yesterday">Yesterday</option>
          <option value="OneWeek">Last Week</option>
          <option value="TwoWeek">Last Two Week</option>
          <option value="OneMonth">Last Month</option>
        </select>
        <div class="input-group-btn" *ngIf="savedFilterId > 0">
          <button class="btn btn-sm btn-danger" (click)="deleteUserFilter()">
            <i class="fa fa-trash"></i>
            <i *ngIf="isDeleteLoader" class="fa fa-circle-o-notch fa-spin"
              style="font-size: .875rem; line-height: 1.5;"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div [ngClass]="getColumnSize()">
    <div [ngClass]="this.urlType === 'Future Updates' ? 'pull-right' : 'pull-right mt-4'">
      <button type="button" dropdownToggle class="btn btn-sm bg-purple text-white ml-2 btn-blue text-white"
        id="btn-search" (click)="SaveFilters()">Save
        <i *ngIf="isLoader" class="fa fa-circle-o-notch fa-spin"
          style="font-size: .875rem; line-height: 1.5;"></i></button>
      <button type="button" class="btn btn-sm bg-purple text-white ml-2 btn-blue text-white" id="btn-search"
        (click)="TriggerAction()">Search</button>
      <button class="ml-2 btn btn-sm pl-1" (click)="resetFilters()">Reset </button>
    </div>
  </div>

</div>
